'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../lib/hooks';

// Services
import { applyCookiesAction, selectCookies } from '../../../lib/features/auth/authSlice';

const Popup = () => {
  const [hydrated, setHydrated] = useState(false);
  const cookies = useAppSelector(selectCookies);

  const dispatch = useAppDispatch();
  const onToggle = () => {
    dispatch(applyCookiesAction());
  };

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;
  if (cookies) return null;
  return (
    <div className="alert alert-success alert-dismissible card cookie-popup shadow rounded py-3 px-4" role="alert">
      <p className="text-muted mb-0 fs-6">
        This website uses cookies to provide you with a great user experience. By using it,
        you accept our
        {' '}
        <Link href="/page-privacy" target="_blank" rel="noopener noreferrer" className="text-success h6">use of cookies</Link>
      </p>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={onToggle} />
    </div>
  );
};

export default Popup;
